import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Form, Button, InputGroup } from "react-bootstrap";
import { MemberPasswordReset } from "../ramnambook-registration/RamNamBookCRUD";

const ChangeForgotPassword = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [loading, setLoading] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    const handleBack = () => {
      window.history.pushState(null, "", window.location.href);
    };
    window.addEventListener("popstate", handleBack);
    return () => {
      window.removeEventListener("popstate", handleBack);
    };
  }, []);

  useEffect(() => {
    if (!state?.memberID) {
      navigate("/change-forgot-pwd", { replace: true });
    }
  }, []);

  useEffect(() => {
    const customer = localStorage.getItem("customer");
    if (customer) {
      navigate("/member/dashboard", { replace: true });
    }
  }, []);

  const isFormValid = newPassword.length > 0 && confirmPassword.length > 0;

  const handleSubmit = async () => {
    if (!newPassword || !confirmPassword) return toast.error("Enter password");
    if (newPassword !== confirmPassword)
      return toast.error("Password does not match");
    try {
      setLoading(true);

      const response = await MemberPasswordReset(state.memberID, newPassword);

      if (response.data.isSuccess) {
        toast.success(response.data.message);

        navigate("/", { replace: true });
      } else toast.error(response.data.message);
    } catch (error) {
      toast.error("Error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center border-0 py-5">
      <div
        className="card p-4 shadow rounded-4 border-none mt-5"
        style={{ maxWidth: "420px", width: "100%" }}
      >
        <h6 className="text-center fw-bold mb-3" style={{ color: "#FF4F00" }}>
          Change Password
        </h6>

        {/* New Password */}

        <Form.Group className="mb-3">
          <Form.Label>New Password</Form.Label>

          <InputGroup>
            <Form.Control
              type={showPassword ? "text" : "password"}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />

            <Button
              variant="outline-secondary"
              onClick={() => setShowPassword(!showPassword)}
            >
              👁
            </Button>
          </InputGroup>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Confirm Password</Form.Label>

          <InputGroup>
            <Form.Control
              type={showConfirmPassword ? "text" : "password"}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />

            <Button
              variant="outline-secondary"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            >
              👁
            </Button>
          </InputGroup>
        </Form.Group>

        {/* Submit */}

        <Button
          className="w-100 mb-2"
          style={{
            background: "#FF4F00",
            border: "none",
          }}
          onClick={handleSubmit}
          disabled={!isFormValid || loading}
        >
          {loading ? "Processing..." : "Reset"}
        </Button>
      </div>
    </div>
  );
};

export default ChangeForgotPassword;
